import Vue from 'vue'
import Router from 'vue-router'
import { createRouterLayout } from 'vue-router-layout'
import store from '@/store'

Vue.use(Router)

//import routes from 'vue-auto-routing'
import routes from './router/routes'

const RouterLayout = createRouterLayout(layout => {
    return import('@/layouts/' + layout + '/index.vue')
})

if (process.env.NODE_ENV == 'development') {
    // console.log('Development mode detected')
}

const router = new Router({
    mode: 'history',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/',
            component: RouterLayout,
            children: routes,
        },
        {
            path: '*',
            redirect: '/',
        },
    ],
})

router.beforeEach((to, from, next) => {
    // Set company on every route that has 'orgId' as a param
    if (to.params.orgId) {
        store.commit('companies/setCompany', to.params.orgId)
    }

    return next()
})

export default router
